import React from 'react';

import AlertIcon from '@/assets/icons/alert';
import { ds } from '@/components/lib/design.system';
import { withOpacity } from '@/styles/styles';

import { PaymentTag } from './PaymentTag';

export const ExpiredCardTag = () => {
    return (
        <PaymentTag
            icon={<AlertIcon color={ds.colorValue.icon.danger} />}
            translationKey="expired"
            color={ds.colorToken.text.danger}
            backgroundColor={withOpacity(ds.colorValue.background.danger.strong, 0.16)}
        />
    );
};
